import type { SalesPerformance, SalesPerformanceResponseDto } from '@/types/sales-performance.types';

export class SalesPerformanceAdapter {
  static fromApi(dto: SalesPerformanceResponseDto): SalesPerformance {
    if (!dto || !Array.isArray(dto.conversationFunnel) || !Array.isArray(dto.nudgeFunnel) || !dto.overview) {
      throw new Error('Sales performance response is unavailable');
    }
    return { ...dto, products: dto.products.map((product) => ({ ...product, title: product.title || product.handle })),
      revenueOverTime: [...dto.revenueOverTime].sort((a, b) => a.date.localeCompare(b.date)) };
  }
}
